module.exports = __webpack_public_path__ + "static/img/extrato_dctf.56be8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/extrato_dctf.png
// module id = 834
// module chunks = 0